module.exports = __webpack_public_path__ + "963e76a8bf4e33fcf087ec8d218fc29c.pdf";